import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export interface AdminUser {
  id: string;
  email: string;
  full_name: string;
  is_super_admin: true;
}

export interface AdminLoginResponse {
  message: string;
  user: AdminUser;
  accessToken: string;
  refreshToken: string;
}

/**
 * Connexion super admin — POST /api/auth/admin/login
 * Retourne 403 si le compte n'est pas super admin
 */
export async function adminLogin(email: string, password: string): Promise<AdminLoginResponse> {
  const response = await axios.post<AdminLoginResponse>(
    `${API_URL}/api/auth/admin/login`,
    { email, password }
  );
  return response.data;
}

/**
 * Vérifier le profil d'un super admin via son token
 */
export async function getAdminProfile(token: string): Promise<any> {
  const response = await axios.get(`${API_URL}/api/auth/profile`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

/**
 * Client axios pour les appels admin authentifiés
 * Utilise la clé localStorage "admin_access_token" (distincte de "access_token")
 */
export const adminApi = axios.create({
  baseURL: API_URL,
  timeout: 20000,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('admin_access_token');
      localStorage.removeItem('admin_refresh_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);
